export default __webpack_public_path__ + "static/media/712.3434383f.gif";